import {Component, Inject, OnInit} from '@angular/core';
import {DeviceService, HttpService} from '@app/core';
import {TokenService} from '@app/core/token/token.service';
import {IndicatorService} from '@app/shared';
import {NotificationService, iNotification} from '@app/shared/notification/notification.service';
import {APP_BASE_HREF} from "@angular/common";
import {WebFolderEnum} from "@app/helper/web-folder.enum";

@Component({
  selector: "navaar-credit-code",
  templateUrl: "./credit-code.component.html",
  styleUrls: ["./credit-code.component.scss"],

})
export class CreditCodeComponent implements OnInit {
  public creditCode: string = "";
  public isLogin: boolean = false;
  public isSubmit: boolean = false;

  constructor(
    @Inject(APP_BASE_HREF) private readonly baseHref: string,
    private readonly tokenService: TokenService,
    private readonly notification: NotificationService,
    private readonly indicator: IndicatorService,
    private readonly http: HttpService,
    public readonly device: DeviceService,
  ) {
    this.indicator.hide();
  }

  ngOnInit(): void {
    this.tokenService.isLogin$.subscribe(c => this.isLogin = c);
  }

  public onShowNotification(e: iNotification) {
    this.notification.setNotification(e);
  }

  public sendCreditCode() {
    if (this.creditCode) {
      this.isSubmit = true;
      this.http.post(`/api/cart/redeem?serialNo=${this.creditCode}`, JSON.stringify({
        redeemText: this.creditCode,
      })).subscribe(
        (res: any) => {
          this.creditCode = "";
          this.isSubmit = false;
          if (res.redirectUrl === "checkout") {
            this.indicator.show(true);
            const regex = new RegExp(WebFolderEnum.webview_new, 'g');
            if (this.device.isAndroid() && regex.test(this.baseHref)) {
              this.device.goToWebWithToken('/app-checkout', WebFolderEnum.webview_new);
            } else {
              this.device.goToWebWithToken('/app-checkout');
            }
          } else if (res.redirectUrl === "credit") {
            let number = this.numberWithCommas(res.addedCredit / 10);
            let message = ` مبلغ ${number} تومان به حساب شما افزوده شد.`;
            this.onShowNotification({text: message, type: "info"});
          }
        },
        (err) => {
          this.isSubmit = false;
          if (err.status == 500) {
            this.onShowNotification({
              text: err.error.message,
              type: "error",
            });
          }
        }
      );
    }
  }

  public onFocusEvent(event) {
    this.creditCode = "";
  }

  public numberWithCommas(x) {
    let parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
}

// {"redirectUrl": "checkout"}
